export const ytThumb = (youtubeId) => `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg`;

export const ytThumbHd = (youtubeId) => `https://i.ytimg.com/vi/${youtubeId}/maxresdefault.jpg`;

export const ytEmbed = (youtubeId) =>
    `https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0`;
